import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ConsultorioAmor.module.scss";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";

const ConsultorioAmor = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, message } = formData;

    emailjs
      .send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        {
          from_name: name,
          from_email: email,
          message,
        },
        process.env.REACT_APP_PUBLIC_KEY,
      )
      .then(
        () => {
          setFormData({
            name: "",
            email: "",
            message: "",
          });

          toast.success(
            "Gracias por enviarnos un mensaje al consultorio del amor :)",
          );

          setTimeout(() => navigate("/"), 2000);
        },
        (error) => {
          console.error(error);

          toast.error(
            "Ha habido un error al enviar el mensaje, inténtalo más tarde.",
          );
        },
      );
  };

  return (
    <section id="love" className={styles.container}>
      <div className={styles.container__content}>
        {/* Decorative elements */}
        <span className={`${styles.heart} ${styles.heartOne}`}>♥</span>
        <span className={`${styles.heart} ${styles.heartTwo}`}>♥</span>
        <span className={`${styles.star} ${styles.starOne}`}>✦</span>
        <span className={`${styles.star} ${styles.starTwo}`}>✦</span>

        {/* Header */}
        <header className={styles.header}>
          <span className={styles.header__eyebrow}>✦ EL CONSULTORIO ✦</span>

          <h1>
            Consultorio <span>del amor</span>
          </h1>

          <p>Sabemos que el amor es una auténtica movida</p>

          <div className={styles.header__line} />
        </header>

        {/* Main */}
        <div className={styles.consultorio}>
          {/* Intro card */}
          <div className={styles.introCard}>
            <div className={styles.introCard__sticker}>💌</div>

            <span className={styles.introCard__small}>QUERIDA / QUERIDO</span>

            <h2>
              Tenemos un
              <br />
              problema de
              <br />
              <span>amor.</span>
            </h2>

            <p>
              ¿Tienes una duda amorosa?
              <br />
              ¿No sabes si escribirle?
              <br />
              ¿Necesitas consejo?
            </p>

            <div className={styles.introCard__note}>
              <strong>Cuéntanos tu movida.</strong>
              <span>Nosotros nos encargamos del resto.</span>
            </div>
          </div>

          {/* Form card */}
          <div className={styles.formCard}>
            <div className={styles.formCard__top}>
              <span>CONSULTORIO</span>
              <span>♡ 01</span>
            </div>

            <div className={styles.formCard__heading}>
              <h2>
                Cuéntanos
                <br />
                <em>tu movida</em>
              </h2>

              <p>
                Puedes contarnos lo que quieras.
                <br />
                Prometemos no juzgarte :)
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <textarea
                name="message"
                value={formData.message}
                placeholder="Escribe aquí tu consulta..."
                onChange={handleInputChange}
                required
              />

              <div className={styles.formCard__footer}>
                <span>🔒 Totalmente anónimo</span>

                <button type="submit">
                  Enviar
                  <span>♥</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <p className={styles.bottomText}>
          Y recuerda: <strong>el amor es una movida</strong>, pero no tienes que
          vivirla a solas.
        </p>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
      />
    </section>
  );
};

export default ConsultorioAmor;
